import { Platform } from "react-native";
export const SELECTED_FARMER = "selected_farmer";

export const isMobile = () => {
  return Platform.OS === "android" || Platform.OS === "ios";
};

export const isMobileDevice = () => {
  if (Platform.OS === "web") {
    const userAgent = navigator.userAgent;
    return /mobile/i.test(userAgent) || /tablet/i.test(userAgent); 
  }
  return true;
};